import React, {useEffect} from "react";
import $ from "jquery";
import "../../style/messageBox.css";

export default function MessageBox(props) {
    let messageBoxTitle = document.querySelector(".messageBoxTitle");
    let messageBoxText = document.querySelector(".messageBoxText");

    useEffect(() => {
        if (props.type === "successMakingRevision") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Revisjon opprettet";
            messageBoxText.innerText =
                "Åpne dokumentet på vanlig vis, og benytt Ktext-tillegget for å levere inn endringene dine. Lykke til med skrivingen :)";

            $(".messageBox").addClass("success").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "successMakingRevision(Fast Revision)") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Revisjon opprettet";
            messageBoxText.innerText = "Revisjon opprettet og sendt til redaktører.";

            $(".messageBox").addClass("success").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "generalFailMessage") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Failed";
            messageBoxText.innerText = "Noe gikk galt :(";

            $(".messageBox").addClass("error").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "SuccessEditUserInfo") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Suksess!";
            messageBoxText.innerHTML = "Du har endret informasjonen din i våre databaser.";

            $(".messageBox").addClass("success").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "WentToManualValidationEditUserInfo") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Sendt til godkjenning.";
            messageBoxText.innerHTML = "Endringene dine vil bli gjennomgått av Karnov og publiseres normalt innen én uke.";

            $(".messageBox").addClass("success").fadeIn(500).delay(9000).fadeOut(1000);
        } else if (props.type === "FailedEditUserInfo") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Failed :(";
            messageBoxText.innerHTML =
                "Det er en feil ved oppdatering av informasjonen din. Prøv igjen. hvis det vedvarer, kontakt Karnov support.";

            $(".messageBox").addClass("error").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "FailedGetUserSensitiveInfo") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Failed :(";
            messageBoxText.innerHTML =
                "Det er en feil ved å hente informasjonen din. Prøv igjen. hvis det vedvarer, kontakt Karnov support.";

            $(".messageBox").addClass("error").fadeIn(500).delay(4000).fadeOut(1000);
        } else if (props.type === "newVersion") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Utdatert version";
            messageBoxText.innerHTML = "Det har kommet en ny versjon av Forfatterportalen. <br/> Vennligst last inn siden på nytt.";

            $(".messageBox").addClass("info").show();
        } else if (props.type === "errorGettingUserInfo") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Error fetching user information";
            messageBoxText.innerText = "Sorry! We couldnot fetch your user account information correctly.";

            $(".messageBox").addClass("error").fadeIn(500).delay(10000).fadeOut(2000);
        } else if (props.type === "successAddMissingSubIds") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Endringene er lagret.";
            messageBoxText.innerHTML = "";

            $(".messageBox").addClass("success").show();
        } else if (props.type === "errorAddMissingSubIds") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Failed!";
            messageBoxText.innerText = "Beklager! Det oppstod en feil under oppdatering av oppgaven din.";

            $(".messageBox").addClass("error").fadeIn(500).delay(10000).fadeOut(2000);
        } else if (props.type === "successCreateWorkitem") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Oppgave opprettet!";
            messageBoxText.innerHTML =
                "Åpne dokumentet på vanlig vis, og benytt Ktext-tillegget for å levere inn endringene dine. Lykke til med skrivingen :)";

            $(".messageBox").addClass("success").show();
        } else if (props.type === "errorCreateWorkitem") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Failed!";
            messageBoxText.innerText = "Beklager! Det oppstod en feil under oppretting av oppgaven din.";

            $(".messageBox").addClass("error").fadeIn(500).delay(10000).fadeOut(2000);
        } else if (props.type === "syncIdCopied") {
            removeMessageClasses();
            messageBoxTitle.innerText = "SyncID kopiert til utklippstavlen!";
            messageBoxText.innerText = "";

            $(".messageBox").addClass("success").fadeIn(200).delay(1500).fadeOut(200);
        } else if (props.type === "SuccessSetToReview") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Oppgaven er lagret og vil bli vurdert av Karnov!";
            messageBoxText.innerText = "";

            $(".messageBox").addClass("success").fadeIn(1000).delay(7000).fadeOut(1000);
        } else if (props.type === "ErrorSetToReview") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Noe gikk galt. Prøv igjen senere.";
            messageBoxText.innerText = "";

            $(".messageBox").addClass("error").fadeIn(1000).delay(7000).fadeOut(1000);
        } else if (props.type === "SuccessContentReviewerApproval") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Oppgaven er godkjent!";
            messageBoxText.innerText = "";

            $(".messageBox").addClass("success").fadeIn(1000).delay(7000).fadeOut(1000);
        } else if (props.type === "ErrorContentReviewerApproval") {
            removeMessageClasses();
            messageBoxTitle.innerText = "Noe gikk galt. Prøv igjen senere.";
            messageBoxText.innerText = "";

            $(".messageBox").addClass("error").fadeIn(1000).delay(7000).fadeOut(1000);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.type]);

    const removeMessageClasses = () => {
        $(".messageBox").hide().removeClass("info").removeClass("success").removeClass("error");
    };

    const closeMessageBox = () => {
        $(".messageBox").hide();
    };
    return (
        <div className="messageBox">
            <h1 className="messageBoxTitle">Title</h1>
            <button type="button" className="btn-close messageBoxCloseBtn" onClick={closeMessageBox}></button>
            <p className="messageBoxText">Message</p>
        </div>
    );
}
